import React from 'react';
import ErrMsgsProvider, { useErrMsgsState } from '../../features/errMsgs';
import styles from './ErrorsBlock.module.scss';

const ErrorsBase = () => {
  const errMsgs = useErrMsgsState();

  if (!errMsgs || errMsgs.length === 0) return null;

  return (
    <ul className={styles.root}>
      {errMsgs.map((msg, index) => (
        <li key={index}>{msg}</li>
      ))}
    </ul>
  );
};

const ErrorsBlock = () => (
  <ErrMsgsProvider>
    <ErrorsBase />
  </ErrMsgsProvider>
);

export default ErrorsBlock;
